import React from 'react';
import * as PropTypes from 'prop-types';
import { MnLoading, MembersProvider } from '../../../index';
import { Layout } from '../organisms/index';
import { TreatmentVideoView } from '../organisms/TreatmentVideoView';

export default class TreatmentVideo extends React.Component {
  render () {
    return (<React.Suspense fallback={ <MnLoading/> }>
      <MembersProvider>
        <Layout state={this.props} showHeader={false} showFooter={false} dsn={this.props.dsn} env={this.props.env}>
          <TreatmentVideoView {...this.props} />
        </Layout>
      </MembersProvider>
    </React.Suspense>);
  }
}

TreatmentVideo.propTypes = {
  dsn: PropTypes.string, // sentry
  env: PropTypes.string, // sentry
};
